const PENDING_KEY = "taistu_blu_pending_v1";
export const BLU_CHAT_UPDATED_EVENT = "taistu-blu-chat-updated";

/** If the tab closed mid-request, pending can remain forever; ignore stale rows. */
const PENDING_MAX_AGE_MS = 35 * 60 * 1000;

export function getBluPending() {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data?.status !== "running") return null;
    const started = data.startedAt ? Date.parse(data.startedAt) : NaN;
    // Missing/invalid startedAt or age: treat as orphan (otherwise "running" never expires).
    if (!Number.isFinite(started) || Date.now() - started > PENDING_MAX_AGE_MS) {
      localStorage.removeItem(PENDING_KEY);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function setBluPending(partial) {
  try {
    localStorage.setItem(
      PENDING_KEY,
      JSON.stringify({
        status: "running",
        phase: "thinking",
        startedAt: new Date().toISOString(),
        ...partial,
      }),
    );
  } catch {
    /* ignore */
  }
}

export function clearBluPending() {
  try {
    localStorage.removeItem(PENDING_KEY);
  } catch {
    /* ignore */
  }
}

export function dispatchBluChatUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(BLU_CHAT_UPDATED_EVENT));
  }
}
